module.exports = __webpack_public_path__ + "img/certificate.afc0b0f5.svg";